import React from "react";
import Pagination from "./Pagination";
import RegularLoader from "../Loader/RegularLoader";

export default function SimpleTable({
  headers = [],
  rows = [],
  currentPage,          // optional
  totalPages,
  onPageChange,
  onRowClick,
  renderActions,
  align = "left",
  showSrNo = false,
  pageSize,
}) {
  const page =
    Number.isFinite(currentPage) && currentPage > 0 ? currentPage : 1;

  const size =
    Number.isFinite(pageSize) && pageSize > 0
      ? pageSize
      : rows.length || 1;

  return (
    <div className="space-y-3">
      <div className="overflow-x-auto">
        <table className="min-w-full text-[10px] sm:text-sm whitespace-nowrap text-left">
          {/* ---------- HEADER ---------- */}
          <thead>
            <tr className="border-b border-slate-100 text-slate-500">
              {showSrNo && (
                <th className="py-1 px-1">Sr No.</th>
              )}

              {headers.map((h, i) => (
                <th key={i} className={`py-1 px-4 text-${align}`}>
                  {h}
                </th>
              ))}

              {renderActions && (
                <th className="py-1 px-1 ">Action</th>
              )}
            </tr>
          </thead>

          {/* ---------- BODY ---------- */}
          <tbody>
            {rows.length === 0 && !onPageChange && (
              <tr>
                <td
                  colSpan={headers.length + (renderActions ? 1 : 0) + (showSrNo ? 1 : 0)}
                  className="py-6  text-slate-400"
                >
                  No data found
                </td>
              </tr>
            )}

            {rows.length === 0 && onPageChange && (
              <tr>
                <td
                  colSpan={headers.length + (renderActions ? 1 : 0) + (showSrNo ? 1 : 0)}
                  className="py-8 whitespace-wrap text-balance" 
                >
                  <div className="flex justify-center">
                    <RegularLoader />
                  </div>
                </td>
              </tr>
            )}

            {rows.map((row, ri) => {
              const isColSpanRow = !Array.isArray(row) && row.colSpan;
              const cells = Array.isArray(row) ? row : row.cells || [];
              const raw = Array.isArray(row) ? row : row.raw;
              const srNo = (page - 1) * size + ri + 1;

              return (
                <tr
                  key={ri}
                  onClick={() => !isColSpanRow && onRowClick?.(raw)}
                  className="border-b border-slate-50 bg-white hover:bg-blue-50/60"
                >
                  {isColSpanRow ? (
                    <td
                      colSpan={
                        row.colSpan +
                        (renderActions ? 1 : 0) +
                        (showSrNo ? 1 : 0)
                      }
                      className="py-8  text-slate-400 whitespace-wrap text-balance" 
                    >
                      {cells[0]}
                    </td>
                  ) : (
                    <>
                      {showSrNo && (
                        <td className="py-1 px-1  text-slate-600 font-medium">
                          {srNo}
                        </td>
                      )}

                      {cells.map((cell, ci) => (
                        <td
                          key={ci}
                          className={`py-1 px-4 text-${align} ${
                            typeof cell === "object" && cell?.className ? cell.className : ""
                          }`}
                        >
                          {React.isValidElement(cell) ? (
                            cell
                          ) : typeof cell === "object" && cell !== null ? (
                            <div
                              className={`flex items-center gap-2 ${
                                align === "center" ? "justify-center " : "justify-start"
                              }`}
                            >
                              {/* IMAGE / AVATAR */}
                              {cell.image && (
                                typeof cell.image === "string" ? (
                                  <img
                                    src={cell.image}
                                    alt=""
                                    className="w-8 h-8 rounded-full object-cover border"
                                  />
                                ) : (
                                  cell.image
                                )
                              )}

                              {/* TEXT CONTENT */}
                              <div className="flex flex-col">
                                <span
                                  className={`text-slate-600 font-medium ${
                                    cell?.className?.includes("whitespace-nowrap")
                                      ? "whitespace-nowrap"
                                      : "whitespace-normal break-words"
                                  }`}
                                >
                                  {cell.title}
                                </span>

                                {cell.sub && (
                                  <span
                                    className={`text-[11px] text-slate-500 ${
                                      cell?.className?.includes("whitespace-nowrap")
                                        ? "whitespace-nowrap"
                                        : "whitespace-normal break-words"
                                    }`}
                                  >
                                    {cell.sub}
                                  </span>
                                )}

                                {cell.extra && (
                                  <span className="text-[10px] text-slate-400">
                                    {cell.extra}
                                  </span>
                                )}
                              </div>
                            </div>
                          ) : (
                            <span className="text-slate-700">{cell}</span>
                          )}

                        </td>
                      ))}

                      {renderActions && (
                        <td
                          className="py-1 px-1"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="flex justify-center items-center w-full">
                            {renderActions(raw)}
                          </div>
                        </td>
                      )}
                    </>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ---------- PAGINATION ---------- */}
      {totalPages > 1 && onPageChange && (
        <div className="flex justify-end py-2">
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
       )} 
    </div>
  );
}


// import { useState } from "react";
// import { Eye } from "lucide-react";
// import { useNavigate } from "react-router-dom";
// import Pagination from "./Pagination";



// export default function SimpleTable({
//   headers,
//   rows,
//   currentPage,
//   totalPages,
//   onPageChange,
//   filter,
// }) {
//   const [selectedRow, setSelectedRow] = useState(null);
//   const navigate = useNavigate();

//   return (
//     <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
//       <div className="lg:col-span-4 space-y-3">
//         <div className="overflow-x-auto">
//       <table className="min-w-full text-xs">
//         <thead>
//           <tr className="border-b border-slate-100 text-slate-500">
//             {headers.map((h, i) => (
//               <th
//                 key={i}
//                 className="p-1  whitespace-nowrap"
//               >
//                 {h}
//               </th>
//             ))}
//             <th className="p-1  whitespace-nowrap">
//               Action
//             </th>
//           </tr>
//         </thead>

//         <tbody>
//           {rows.map((row, ri) => (
//             <tr
//               key={ri}
//               onClick={() => setSelectedRow(ri)}
//               className={`border-b border-slate-50 cursor-pointer hover:bg-blue-50/60 ${
//                       selectedRow === ri ? "bg-blue-50" : "bg-white"
//                     }`}
//             >
//               {row.map((cell, ci) => (
//                 <td
//                   key={`${ri}-${ci}`}
//                   className="py-2"
//                 >
//                   <div className="font-medium text-slate-800">{cell}</div>
                  
//                 </td>
//               ))}

//               {/* View Button */}
//               <td className="px-4 py-2">
//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation(); // prevent row highlight trigger
//                     navigate(`/retailer/${row[0]}`); // row[0] = ID or adjust accordingly
//                   }}
//                   className="px-3 py-1 rounded-lg bg-blue-600 text-white text-xs flex items-center gap-1 hover:bg-blue-700"
//                 >
//                   <Eye size={14} />
//                   View
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {/* Pagination */}
     
//       {/* {!filter && totalPages > 1 && ( */}
//         <div className="py-3 flex justify-end">
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={onPageChange}   // ✔ use the prop passed from parent
//           />
//         </div>
//       {/* )} */}

//     </div>
//       </div>
      
//     </div>
    
//   );
// }




// export default function SimpleTable({ headers, rows }) {
//   return (
//     <div className="overflow-x-auto rounded-2xl border bg-white shadow-sm">
//       <table className="min-w-full text-sm">
//         <thead className="bg-slate-50">
//           <tr className="text-left text-[11px] sm:text-xs uppercase tracking-wide text-slate-500">
//             {headers.map((h, i) => (
//               <th key={i} className="px-3 sm:px-4 py-2 sm:py-3 whitespace-nowrap">{h}</th>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {rows.map((r, ri) => (
//             <tr key={ri} className="border-b last:border-0">
//               {r.map((c, ci) => (
//                 <td key={`${ri}-${ci}`} className="px-3 sm:px-4 py-2 sm:py-3 whitespace-nowrap">{c}</td>
//               ))}
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }